import { render } from "./WarehouseReport.vue?vue&type=template&id=7ff6fddc"
import script from "./WarehouseReport.vue?vue&type=script&lang=js"
export * from "./WarehouseReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__